export default __webpack_public_path__ + "static/anthony-cahill-868ab6c58c966bc215a24a4d78894811.png";